var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-content"},[_c('schedule-center',{attrs:{"base-url":_vm.serveUrl,"admin-center-url":_vm.adminCenterUrl,"request":_vm.request,"show-calendar":"","showFilter":_vm.HIDE_SCHEDULE_SEARCH !== '1'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }